import GoodsHeader from "../goods/header";
import GoodsFooter from "../goods/footer";
import { Outlet } from "react-router-dom"
import { CartProvider } from "../../context/cart-context"
import { OrderProvider } from "../../context/order-context"

import "../../index.css"

export default function GoodsLayout() {
  return (
    <CartProvider>
      <OrderProvider>
        <div className="min-h-screen flex flex-col">
          <GoodsHeader />
          <main className="flex-grow bg-gray-50">
            <Outlet />
          </main>
          <GoodsFooter />
        </div>
      </OrderProvider>
    </CartProvider>
  )
}
